module.exports = __webpack_public_path__ + "static/media/bg_shape_1.0c389974.png";